export default __webpack_public_path__ + "fonts/bec607a1fc078c7fe36ed448432e3b01.svg";